import { OidcMetadata } from 'oidc-client-ts';

import { CONFIG } from '~src/config/config';

export const AppFetchConfig = {
  apiUrl: CONFIG.API_URL,
  cdnUrl: CONFIG.CDN_URL,
  defaultDebounceWaitTime: 300,
};

export const AppAuthConfig = {
  authority: CONFIG.AUTH0_DOMAIN,
  client_id: CONFIG.AUTH0_CLIENT_ID,
  redirect_uri: CONFIG.AUTH0_REDIRECT_URI,
  scope: 'openid email offline_access',
};

export const AppAuthMetadata: Partial<OidcMetadata> = {
  issuer: AppAuthConfig.authority,
  authorization_endpoint: `${AppAuthConfig.authority}/authorize`,
  token_endpoint: `${AppAuthConfig.authority}/oauth/token`,
  userinfo_endpoint: `${AppAuthConfig.authority}/userinfo`,
  jwks_uri: `${AppAuthConfig.authority}/.well-known/jwks.json`,
  end_session_endpoint: `${AppAuthConfig.authority}/v2/logout`,
  introspection_endpoint: `${AppAuthConfig.authority}/oauth/introspect`,
  revocation_endpoint: `${AppAuthConfig.authority}/oauth/revoke`,
};
